<template>
  <v-card
    class="rounded-xl d-inline-block overflow-hidden"
    min-height="100%"
    min-width="100%"
    style="z-index: 33"
    outlined
    elevation="0"
  >

    <the-action-header-card-arch
      @openInfo="reveal = true"
      @editAchievement="editAchievement(achievement)"
      @deleteAchievement="deleteAchievement(achievement.id)"
      :achievement-comments="achievement.comments"
    />

    <the-achievement-name-and-type-card-arch
      :achievement = achievement
    />

    <the-unit-section-card-arch
      :achievement="achievement"
    />

    <the-file-section-card-ach
      :achievement="achievement"
    />

    <trophy
      class="card-img"
      width="180px"
      height="180px"
    />

    <v-expand-transition>
      <the-additional-info-card-ach
        v-if="reveal"
        :achievement="achievement"
        :revel="reveal"
        @closeCard="reveal = false"
      />
    </v-expand-transition>
  </v-card>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import Trophy from "../Icons/Trophy";

const TheUnitSectionCardArch = () => import("./CardAchievementElements/TheUnitSectionCardArch.vue");

const TheAchievementNameAndTypeCardArch = () => import("./CardAchievementElements/TheAchievementNameAndTypeCardArch.vue");
const TheActionHeaderCardArch = () => import("./CardAchievementElements/TheActionHeaderCardArch.vue")

const TheFileSectionCardAch = () => import("./CardAchievementElements/TheFileSectionCardAch.vue");

const TheAdditionalInfoCardAch = () => import("./CardAchievementElements/TheAdditionalInfoCardAch.vue");

export default {
  name: "CardAchievements",

  components: {
    Trophy,
    TheActionHeaderCardArch,
    TheAchievementNameAndTypeCardArch,
    TheUnitSectionCardArch,
    TheFileSectionCardAch,
    TheAdditionalInfoCardAch
  },

  data() {
    return {
      reveal: false,
    }
  },

  props: {
    achievement: {
      Type: Object,
      required: true
    }
  },

  methods: {
    ...mapMutations({
      editAchievement: 'achievement/editAchievement',
    }),

    ...mapActions({
      deleteAchievement: 'achievement/deleteAchievement',
    }),
  },

}
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 1;
  z-index: 999;
  position: absolute;
  width: 100%;
}

.card-img {
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  /*background: #2185d0;*/
  object-fit: contain;
  opacity: 0.05;
  overflow: hidden;
  transform: translate(45px, 45px);
}

.up-z-index {
  z-index: 200;
}
</style>